import { fireHeapEvent } from '../helpers'
import eventNames from '../constants/tagging'

const e = {
  Revenue_SignUpPage_Clicked_SignUpButton(signupButtonType: string): void {
    const { Revenue_SignUpPage_Clicked_SignUpButton } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_SignUpButton, { signupButtonType })
  },
  Revenue_SignUpPage_Clicked_SignInButton(): void {
    const { Revenue_SignUpPage_Clicked_SignInButton } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_SignInButton)
  },
  Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox(isChecked: boolean): void {
    const { Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox, { isChecked })
  },
  Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox(): void {
    const { Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox } = eventNames
    fireHeapEvent(Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox)
  }
}

export default e
